import { Injectable } from '@angular/core';
import { Subject } from "rxjs/Subject";
import { Observable } from "rxjs/Observable";

import { CustomHttpService } from './custom-http.service';
import { HttpOptionsModel } from '../models';

@Injectable()
export class GameService {

  private currentGameTypeId = new Subject();
  private currentBrandId = new Subject();

  constructor(private customHttpService: CustomHttpService) { }



  getAllGamesByFilter(type,gameType){
    var postData = {};
    if(gameType){
      postData = {
        groupType: 2
      }
    }
    else {
      postData = {
        type: type
      }
    }
    let httpOptions = new HttpOptionsModel('/list-games', postData, false, true);
    return this.customHttpService.post(httpOptions);
  }
  getAllGames() {
    let httpOptions = new HttpOptionsModel('/all-games', null, false, true);
    return this.customHttpService.post(httpOptions);
  }
  getGamesById(gameId: string) {
    const postData = {
      group: gameId
    };
    let httpOptions = new HttpOptionsModel('/group-games', postData, false, true);
    return this.customHttpService.post(httpOptions);
  }

  getNovusbet()
  {
    const postData = {

    };
    let httpOptions = new HttpOptionsModel('/novusbet', postData, false, true);
    return this.customHttpService.post(httpOptions);
  }

  getGoldenRace()
  {
    const postData = {

    };
    let httpOptions = new HttpOptionsModel('/golden-race-game', postData, false, true);
    return this.customHttpService.post(httpOptions);
  }

  getGameLinkById(gameId: string, isMobile: number, domain: string) {
    const postData = {
      game_id: gameId,
      mobile: isMobile,
      return_url: domain
    };
    let httpOptions = new HttpOptionsModel('/game', postData, false, true);
    return this.customHttpService.post(httpOptions);

  }
  getGameTypes(type: string) {
    const postData = {
      type: type
    };
    let httpOptions = new HttpOptionsModel('/game-types', postData, false, true);
    return this.customHttpService.post(httpOptions);
  }
  getCurrentGameTypeId(): Observable<any> {
    return this.currentGameTypeId.asObservable();
  }
  setCurrentGameTypeId(gameType): void {
    this.currentGameTypeId.next(gameType);
  }
  getCurrentBrandId(): Observable<any>{
    return this.currentBrandId.asObservable();
  }
  setCurrentBrandId(brandId): void{
    this.currentBrandId.next(brandId);
  } 

}



// WEBPACK FOOTER //
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/shared/services/game.service.ts